import React from 'react';
import RoleBasedLayout from './RoleBasedLayout';

const JefeSeleccionLayout = () => {
  console.log('JefeSeleccionLayout renderizando...');
  return <RoleBasedLayout roleName="Jefe de Selección" colorClass="primary" />;
};

export default JefeSeleccionLayout;
